import { DocumentImages } from "./features/DocumentImages";
import { UploadedMediaAssets } from "./features/UploadedMediaAssets";
import { StockAssets } from "./features/StockAssets";
import { MediaAssetTabs, MediaAssetsViewOptions, MediaKind } from "../../../types";
import { useTemplateData } from "../../../hooks/useTemplateData";
import { AIGeneratedImages } from "./features/AIGeneratedImages";

export const ImagesTab = ({
  previewWidth,
  previewHeight,
  mediaAssetTabView,
  customAddToCanvas,
  onReplaceSelectedAsset,
  selectionMode,
}: {
  previewWidth: number;
  previewHeight: number;
  mediaAssetTabView: MediaAssetsViewOptions;
  customAddToCanvas?: (assetId: string, path: string) => void;
  onReplaceSelectedAsset?: (
    assetId: string,
    path: string,
    mediaType: MediaKind
  ) => void;
  selectionMode?: boolean;
}) => {
  const {
    templatesData: { storyboardId },
    assetLibrariesData: { organizationAssetLibraries, projectAssetLibraryId },
    projectId,
    brandKitData: { brandKitPalette },
    organizationId,
  } = useTemplateData();

  // take most recent org lib by default
  const organizationAssetLibraryId = organizationAssetLibraries[0]?.id;

  const galleryProps = {
    customAddToCanvas,
    selectionMode,
    onReplaceSelectedAsset,
  };

  return (
    <>
      {mediaAssetTabView === MediaAssetsViewOptions.Document &&
        projectAssetLibraryId && (
          <DocumentImages
            assetLibraryId={projectAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
            {...galleryProps}
          />
        )}
      {mediaAssetTabView === MediaAssetsViewOptions.Stock &&
        organizationAssetLibraryId && (
          <StockAssets
            assetLibraryId={organizationAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
            mediaAsset={MediaAssetTabs.Images}
            {...galleryProps}
          />
        )}
      {mediaAssetTabView === MediaAssetsViewOptions.Uploads &&
        organizationAssetLibraryId &&
        organizationId && (
          <UploadedMediaAssets
            organizationId={organizationId}
            assetLibraryId={organizationAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
            mediaAsset={MediaAssetTabs.Images}
            {...galleryProps}
          />
        )}
      {mediaAssetTabView === MediaAssetsViewOptions.AIGenerated &&
        storyboardId &&
        organizationAssetLibraryId &&
        projectId && (
          <AIGeneratedImages
            assetLibraryId={organizationAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
            projectId={projectId}
            storyboardId={storyboardId}
            palette={brandKitPalette}
            {...galleryProps}
          />
        )}
    </>
  );
};
